'use client'

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setThemesData } from '../reduxToolkit/themeNameSlice'

export default function InitializeThemes({ currentTheme, websiteTheme }) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setThemesData({ currentTheme, websiteTheme }))
  }, [currentTheme, websiteTheme, dispatch])

  return null
}
